<div class="container animated fadeIn">
  <div class="hero">

    <div class="backbutton">
      <a [routerLink]="['/heroes']">
        <svg class="bi bi-arrow-left" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"/>
          <path fill-rule="evenodd" d="M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
      </a>
    </div>

    <div class="hero__img">
      <img [src]="hero.img" alt="">
    </div>

    <div class="hero__name">
      <h1> {{ hero.nombre }} </h1>
    </div>

    <div class="hero__details">

      <div class="hero__details--house" *ngIf=" hero.casa === 'Marvel'; else DC">
        <h6 class="hero__details--house--marvel">Marvel</h6>
      </div>

      <ng-template class="hero__details--house" #DC>
        <h6 class="hero__details--house--dc">DC</h6>
      </ng-template>

      <div class="hero__details--date">
        <h6> {{ hero.aparicion | date: 'MMMM, y' }} </h6>
      </div>
    </div>

    <div class="hero__bio">
      <p> {{ hero.bio }} </p>
    </div>

    <div class="hero__recomendations">
      <div class="hero__recomendations--title">
        <h3>See other super heroes of {{ hero.casa }}</h3>
      </div>
      <div class="hero__recomendations--container">

        <div *ngFor="let recomendation of heroes">
          <div class="recomendation" *ngIf="recomendation.casa === hero.casa && recomendation.nombre != hero.nombre">
            <a (click)="showRecomendation( recomendation.id )" >
              <img [src]="recomendation.img" alt="">
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>